import {MutationResult, QueryResult} from "@apollo/client/react/types/types";
import {OperationVariables} from "@apollo/client/core";
import {Loader} from "../Loader/Loader";
import {Box} from "@mui/material";
import React from "react";

type Props = {
    data: QueryResult<any,any> | MutationResult<any>;
    children: React.ReactNode
}

export const UseQuerySuspense: React.FC<Props> = ({data, children}) => {
   
    if(data.loading && !data.data) return (<Box sx={{width:'100%',display:'flex', justifyContent:'center',height:'65px' }}>
        <Loader sx={{justifySelf:'center'}}/>
    </Box>);
    
    if(!data.loading && data.error!==undefined)
        return( <>An error has occured</>);
    
    return(<>{children}</>);
}
